import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ModalDismissReasons, NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Customer, ICustomer} from '../../shared/model/customer.model';
import {CustomerService} from '../customer/customer.service';
import {IOrderState} from '../../shared/model/order-state.model';
import {IProject, Project} from '../../shared/model/project.model';
import {IRunModel} from "../process/model/runModel.model";
import {BpmsService} from "../process/service/bpms.service";
import {ContractUpdateComponent} from "../contract/contract-update.component";
import {Contract, IContract} from "../../shared/model/contract.model";
import {Employee, IEmployee} from "../../shared/model/employee.model";
import {ContractService} from "../contract/contract.service";
import {EmployeeService} from "../../core/employee/employee.service";
import {OrderAddComponent} from "../order/order-add.component";
import {ProjectService} from "./project.service";
import {TransactionService} from "../transaction/transaction.service";
import {ITransaction} from "../../shared/model/transaction.model";
import {NgxSpinnerService} from "ngx-spinner";
import {IStep} from "../../shared/model/step.model";
import {StepService} from "../step/step.service";
import * as moment from 'jalali-moment';
import {COMPANY_NAME, SHOW_SALES_PARAM} from "../../app.constants";
import {ISalesCycle, SalesCycle} from "../../shared/model/salesCycle.model";
import {SalesCycleService} from "../salesCycle/sales-cycle.service";


@Component({
  selector: 'app-project-update',
  templateUrl: './project-update.component.html'
})
export class ProjectUpdateComponent implements OnInit {
  @Input() projectEdit;
  @Input() customerId;
  @Input() action;
  @Input() projectItems;
  @Input() salesCycles_list;

  project: IProject = new Project();
  isSaving: boolean;
  showContractForm = false;
  customers: ICustomer[];
  contract: IContract = new Contract();
  employees: IEmployee[];
  steps: IStep[];
  closeResult: string;
  transactons: ITransaction[] = [];
  showMsg: boolean = false;

  startDateObject: any;
  endDateObject: any;
  endDateRealObject: any;
  company_name: any = COMPANY_NAME;
  show_sales_param: any = SHOW_SALES_PARAM;


  salseCycles: ISalesCycle[];
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  keyword = 'title';
  customer: ICustomer = new Customer();

  selectEvent(item) {
    this.project.customer = new Customer(item.id);
    this.loadAllSalesCycleWithCustomerId(item.id);

  }

  onChangeSearch(val: string) {
    this.customer.title = val;
    this.search(this.page);
  }


  onFocused(e) {
  }


  onClosed(e) {
    this.project.customer = null;

  }

  constructor(// protected orderStateService: OrderStateService,
    protected projectService: ProjectService,
    protected transactionService: TransactionService,
    protected customerService: CustomerService,
    protected salesCycleService: SalesCycleService,
    protected activatedRoute: ActivatedRoute,
    protected activeModal: NgbActiveModal,
    protected bpmsService: BpmsService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    public contractService: ContractService,
    public stepService: StepService,
    protected employeeService: EmployeeService) {

    this.itemsPerPage = 1000;
    this.page = 1;
    this.predicate = 'itemName';
    this.reverse = 'asc';
  }

  ngOnInit() {
    // alert(' in ng customerId == ' + this.customerId)
    this.isSaving = false;


    if (this.projectEdit) {
      this.projectService.find(this.projectEdit).subscribe(
        (res: HttpResponse<IProject>) => {
          this.project = res.body;
          if (this.project.start) {
            const jalaliDate5 = moment(this.project.start).locale('fa').format('jYYYY/jM/jD HH:mm:ss'); // 1367/11/4
            this.startDateObject = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
          }
          if (this.project.end) {
            const jalaliDate_end = moment(this.project.end).locale('fa').format('jYYYY/jM/jD HH:mm:ss'); // 1367/11/4
            this.endDateObject = moment(jalaliDate_end, 'jYYYY,jMM,jDD  HH:mm:ss');
          }
          if (this.project.endReal) {
            const jalaliDate_end_real = moment(this.project.endReal).locale('fa').format('jYYYY/jM/jD HH:mm:ss'); // 1367/11/4
            this.endDateRealObject = moment(jalaliDate_end_real, 'jYYYY,jMM,jDD  HH:mm:ss');
          }

          if (this.action === 'close') {
            this.spinner.show();
            this.transactionService
              .checkForCloseProject(this.project.id)
              .subscribe(
                // (res2: HttpResponse<ITransaction[]>) => this.paginateTransaction(res2.body, res2.headers),
                (res: HttpResponse<any>) => {
                  this.showMsg = res.body;
                  this.spinner.hide();
                },
                (res2: HttpErrorResponse) => this.onError(res2.message)
              );


          }

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }

    if (this.customerId) {

      this.project.customer = new Customer(this.customerId);

    }
    this.loadAllEmployee();
    this.loadAllStep();
    if (this.salesCycles_list) {
      this.salseCycles = this.salesCycles_list;
    }

  }


  sort2(predicate, reverse) {
    let result = ['id, desc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }

  loadAllSalesCycleWithCustomerId(id) {

    const customerId = id;
    this.salesCycleService
      .findWithCustomerId({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort2(this.predicate, this.reverse),
        customerId
      }, customerId)
      .subscribe(
        (res: HttpResponse<ISalesCycle[]>) => this.paginateSalesCycle(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  protected paginateSalesCycle(data: IProject[], headers: HttpHeaders) {

    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.salseCycles = data;

  }

  search(page) {

    if (page) {
      this.page = page;
    } else {
      this.page = 1;

    }

    this.spinner.show();

    const title = (this.customer.title ? this.customer.title : '');

    this.customerService
      .searchAnutocomplete({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: ['title,asc'],
        title

      })
      .subscribe(
        (res: HttpResponse<ICustomer[]>) => this.paginateCustomers(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }

  protected paginateCustomers(data: ICustomer[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.customers = data;
    this.spinner.hide();
  }

  // protected paginateTransaction(data: IProject[], headers: HttpHeaders) {
  //   // this.totalItems_finalFollow = parseInt(headers.get('X-Total-Count'), 10);
  //   // this.queryCount_finalFollow = this.totalItems_finalFollow;
  //   this.transactons = data;
  //   this.spinner.hide();
  //
  //   if(this.transactons && this.transactons.length>0){
  //     this.showMsg = true;
  //   }
  // }


  loadAllEmployee() {
    this.employeeService.query().subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  previousState() {
    window.history.back();
  }


  // startPrc() {
  //   this.isSaving = true;
  //
  //   this.bpmsService.startBoostan(this.project.id, this.project.address,this.project.customer.title).subscribe((res: HttpResponse<IRunModel>) => {
  //       console.log(' ---- in startPrc ------ res.body ==' + res.body);
  //       this.isSaving = false;
  //       this.clear();
  //
  //     },
  //     (res: HttpErrorResponse) => this.onError(res.message)
  //   );
  // }

  save() {
    this.isSaving = true;
    // alert('this.customerId==' + this.customerId);
    const span_startDate = document.getElementById('span_startDate');
    if (span_startDate) {
      this.project.start = (<HTMLInputElement>span_startDate).innerHTML;
    }
    const span_endDate = document.getElementById('span_endDate');
    if (span_endDate) {
      this.project.end = (<HTMLInputElement>span_endDate).innerHTML;
    }
    const span_endDate_real = document.getElementById('span_endDate_real');
    if (span_endDate_real) {
      this.project.endReal = (<HTMLInputElement>span_endDate_real).innerHTML;
    }

    if (this.customerId) {
      this.project.customer = new Customer(this.customerId);
    }
    if (this.project.salesCycle_str) {
      this.project.salesCycle = new SalesCycle(this.project.salesCycle_str);
    }

    if (this.project.status && this.action === 'close' && this.project.close_status) {
      this.project.status = this.project.close_status;
      this.project.closed = true;
      if (this.project.status === 'closed_successfully') {
        // if (this.steps && this.steps.length > 0) {
        //   this.project.step = this.steps[this.steps.length - 1].itemName;
        //   this.project.step_number = this.steps[this.steps.length - 1].score;
        // }
        if (this.projectItems && this.projectItems.length > 0) {
          this.project.step = this.projectItems[this.projectItems.length - 1].title;
          this.project.step_number = this.projectItems[this.projectItems.length - 1].score;
        }
      }
      if (this.project.status === 'colesd_contract') {
        // alert('this.project.step= '+this.project.step);
        this.project.step = 'completed';
      }
      if (this.project.status === 'colesd_order') {
        // alert('this.project.step= '+this.project.step);
        this.project.step = 'completed';
      }

    }
    if (this.project.id !== undefined) {
      this.subscribeToSaveResponse(this.projectService.update(this.project));
    } else {
      this.project.status = 'notStarted';
      this.subscribeToSaveResponse(this.projectService.create(this.project));
    }
  }

  reform() {
    this.isSaving = true;
    // alert('this.customerId==' + this.customerId);
    if (this.customerId) {
      this.project.customer = new Customer(this.customerId);
    }
    if (this.project.id !== undefined) {
      this.subscribeToSaveResponse(this.projectService.reform(this.project));
    }
  }


  loadAllStep() {
    this.stepService.query({
      page: 0,
      size: 20,
      sort: ['score', 'asc']

    }).subscribe(
      (res: HttpResponse<IStep[]>) => {
        this.steps = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IProject>>) {

    result.subscribe((res: HttpResponse<IProject>) => this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccess(res) {

    this.isSaving = false;
    // this.project = res;
    // this.startPrc();

    if (this.project.status === 'colesd_contract') {
      this.showContractForm = true;
    } else if (this.project.status === 'colesd_order') {
      this.clear();
      this.openOrderForm()
    } else {

      this.clear();

    }
    // this.previousState();
  }

  openOrderForm() {
    this.modalService.open(OrderAddComponent, {windowClass: 'sm', backdrop: 'static'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      // alert(' in 00000');

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      alert(' in 1111' + reason);
      // this.search(1);
    });
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  openContract(project) {

    const modalRef = this.modalService.open(ContractUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.type = 'Task';
    // modalRef.componentInstance.customerId = this.customer.id;
    modalRef.componentInstance.project = project;


    modalRef.result.then(
      res => {
        // this.loadContracts();
      },
      rejected => {
        // this.loadContracts();
      }
    );

  }

  protected onSaveError() {
    // alert(' iin onSaveError ');

    this.isSaving = false;
  }

  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  trackCustomerById(index: number, item: ICustomer) {
    return item.id;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


  clearForm() {
    // this.showForm = false;
    this.activeModal.dismiss('cancel');
  }


  saveContract() {
    this.isSaving = true;
    if (this.contract.cost) {
      this.contract.cost = this.disNumberWithCommas(this.contract.cost);
    }
    const span_startDate = document.getElementById('span_startDate');
    if (span_startDate) {
      this.contract.start = (<HTMLInputElement>span_startDate).innerHTML;
      // alert(' this.transaction.jalaliDate ==' + this.transaction.jalaliDate);
    }
    const span_endDate = document.getElementById('span_endDate');
    if (span_endDate) {
      this.contract.end = (<HTMLInputElement>span_endDate).innerHTML;
      // alert(' this.transaction.jalaliDate ==' + this.transaction.jalaliDate);
    }
    // alert('span_startDate==' + span_startDate);
    // alert('this.contract.startDate ==' + this.contract.startDate );


    if (this.customerId) {
      this.contract.customer = new Customer(this.customerId);

    } else {

      // this.search(1);
    }
    // alert('this.project==' + this.project);
    if (this.project) {
      // alert(' in if this.project');
      this.contract.project = this.project;
      this.contract.customer = this.project.customer;
    }
    // this.contract.organization = new Organization(1);
    if (this.contract.employee_str) {
      this.contract.employee = new Employee(this.contract.employee_str);
    }
    if (this.contract.id !== undefined && this.contract.id != null) {
      this.subscribeToSaveResponseContract(this.contractService.update(this.contract));
    } else {
      this.subscribeToSaveResponseContract(this.contractService.create(this.contract));
    }
  }


  protected subscribeToSaveResponseContract(result: Observable<HttpResponse<IContract>>) {
    result.subscribe((res: HttpResponse<IContract>) => this.onSaveSuccessContract(), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccessContract() {
    this.isSaving = false;
    // this.activeModal.dismiss('cancel');
    // this.showForm = false;
    // this.loadAll();
    // if(this.customerId) {
    this.clear();
    // }
    // this.previousState();
  }


  numberWithCommasNumber() {
    const cost = this.contract.cost;
    const y = this.numberWithCommas(cost);
    // this.editForm.patchValue({
    //   cost: y
    // });
    this.contract.cost = y;
  }

  numberWithCommas(x) {

    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');

    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) {
      x = x.replace(pattern, '$1,$2');
    }
    return x;

  }

  disNumberWithCommas(x) {
    if (x) {
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');

      return x;
    }
  }


}
